import React, { useState, useEffect } from "react";
import Axios from "axios";
import DepartmentCard from "./DepartmentCard";
import RingLoader from "react-spinners/RingLoader";
import { X } from "@phosphor-icons/react";

const Modal = ({ department, close }) => {
  function handleClick(e) {
    e.stopPropagation();
  }
  let size;
  if (window.screen.width < 768) {
    size = 24; // Size for mobile devices
  } else if (window.screen.width <= 1024) {
    size = 30; // Size for tablets
  } else {
    size = 36; // Size for desktops
  }
  //HANDLING API CALL
  const [teamData, setTeamData] = useState([]);
  const [isDataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    Axios.get(
      "https://website-backend-taupe.vercel.app/api/position/" + department
    ).then((response) => {
      const totalItems = response.data.length;
      const splitIndex = Math.floor(totalItems / 2);
      const firstHalf = response.data.slice(0, splitIndex);
      setTeamData(firstHalf);
      setDataLoaded(true);
    });
  }, []);

  return (
    <div
      className="h-[100%] w-[90%] md:h-[80%] relative modal-class rounded-2xl  flex flex-col items-center justify-center "
      onClick={handleClick}
    >
      {/* ------------------------------ Cancel Button ----------------------------- */}
      <button
        className={`${
          size === 24 ? "top-1 right-1" : "top-4 right-4"
        } absolute pr-2`}
        onClick={close}
      >
        <X size={size} color="#ffffff" />
      </button>

      {/* --------------------------------- HEADING -------------------------------- */}
      <h1 className="text-xl md:text-2xl font-popp font-semibold text-center pt-6 md:pt-8 px-2 mt-2 mb-6">
        <span className="text-secondary">{department}</span>
        <span className="pl-2 md:pl-4">OC Members</span>
      </h1>
      {/* ---------------------------------- CARDS List--------------------------------- */}
      {isDataLoaded ? (
        <div className=" overflow-auto w-full scrollbar-thumb-secondary scrollbar-track-[#555] scrollbar-thin">
          {/* ---------------------------- INDIVIDUAL CARDS ---------------------------- */}

          <div className="grid 2xl:grid-cols-6 lg:grid-cols-5 lg:gap-20 md:grid-cols-4 mobile:grid-cols-3 md:gap-12 grid-cols-2 gap-8">
            {teamData.map((data) => (
              <DepartmentCard key={data._id} data={data} />
            ))}
          </div>
        </div>
      ) : (
        <RingLoader color="#4be4c0" loading size={80} speedMultiplier={1} />
      )}
    </div>
  );
};

export default Modal;

// DIv CLASSNAME - className='h-[60%] w-[80%] relative modal-class flex rounded-2xl justify-center items-center'
